var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18C14.4183 18 18 14.4183 18 9.99999C18 5.8551 14.8478 2.44644 10.8099 2.04048V11.6885L12.9257 9.75644C13.2381 9.46981 13.733 9.48467 14.0267 9.7896C14.1695 9.93748 14.2442 10.1307 14.2381 10.3339C14.232 10.5374 14.1444 10.7261 13.992 10.8656L10.5474 14.0112C10.408 14.1385 10.224 14.2106 10.029 14.2144L10.0015 14.2159L9.97867 14.2148C9.77638 14.2106 9.59238 14.1385 9.45333 14.0112L6.00876 10.8656C5.856 10.7261 5.76876 10.5374 5.76229 10.3339C5.75657 10.1307 5.83124 9.93748 5.9741 9.7896C6.26781 9.48467 6.76229 9.47019 7.07467 9.75644L9.19086 11.6885V2.04041C5.15258 2.44602 2 5.85484 2 9.99999C2 14.4183 5.58172 18 10 18Z",
    fill: "#2D49FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.365306df.svg";
export { ForwardRef as ReactComponent };